define("shared/components/shared/ui/switcher/trigger", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Ui::Switcher::Option @loading={{@loading}} @onClick={{(noop)}} @option={{@option}} data-qa-id={{@qaId}} />
  */
  {
    "id": "5EyWPZwm",
    "block": "[[[8,[39,0],[[16,\"data-qa-id\",[30,1]]],[[\"@loading\",\"@onClick\",\"@option\"],[[30,2],[28,[37,1],null,null],[30,3]]],null]],[\"@qaId\",\"@loading\",\"@option\"],false,[\"shared/ui/switcher/option\",\"noop\"]]",
    "moduleName": "shared/components/shared/ui/switcher/trigger.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});